import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationsService } from '@app/core/services/validations.service';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { AccountingService } from '@core/services/accounting.service';
import { GeneralsService } from '@core/services/generals.service';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-movement-interface-download',
  templateUrl: './movement-interface-download.component.html'
})
export class MovementInterfaceDownloadComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public movementForm: FormGroup;
  public minDate = moment().subtract(91, 'days');
  public maxDate = moment().subtract(1, 'days');

  constructor(
    public appConfig: AppConfig,
    public accountingService: AccountingService,
    public generalsService: GeneralsService
  ) {}

  ngOnInit() {
    this.movementForm = new FormGroup({
      typeDate: new FormControl('accountant', Validators.required),
      date: new FormControl('', [
        Validators.required,
        ValidationsService.isDateBetweenNinetyDaysFromYesterday
      ])
    });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.movementForm;
    if (form.dirty && form.valid) {
      const loading = this.generalsService.loading();
      this.accountingService
        .downloadMovementInterface(form)
        .pipe(takeUntil(this.constants.destroy$))
        .subscribe(
          result => {
            const fileName = this.generalsService.getFileName(
              result.headers.get('content-disposition')
            );
            this.generalsService.download(fileName, 'txt', result);
            loading.close();
          },
          error => {
            loading.close();
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.generalsService.showError(error)
            );
          }
        );
    }
  }

  changeTypeDate(event: any) {
    const controlDate = this.movementForm.controls['date'];
    controlDate.clearValidators();
    if (event.value === 'interface') {
      this.maxDate = moment();
      this.minDate = moment().subtract(90, 'days');
      controlDate.setValidators([
        Validators.required,
        ValidationsService.isDateBetweenNinetyDaysFromToday
      ]);
    } else {
      this.maxDate = moment().subtract(1, 'days');
      this.minDate = moment().subtract(91, 'days');
      controlDate.setValidators([
        Validators.required,
        ValidationsService.isDateBetweenNinetyDaysFromYesterday
      ]);
    }
    controlDate.updateValueAndValidity();
  }
}
